import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

// URL and endpoint constants
const API_URL = process.env.API_BASE_URL

const getPDFGuiaRemessaMalote = (parameters) => {
  const GUIA_REMESSA_MALOTE_PDF_URL = API_URL + 'relatorios/malote'
  let config = {
    method: 'get',
    url: GUIA_REMESSA_MALOTE_PDF_URL,
    params: {
      inicio: parameters.dataInicio + 'T' + parameters.horaInicio,
      fim: parameters.dataFim + 'T' + parameters.horaFim,
      idsUnidades: parameters.idsUnidades
    },
    responseType: 'arraybuffer',
    credentials: true
  }
  return Vue.http(config)
}

const getPDFDocumentosDesarquivadosSetor = (parameters) => {
  const GUIA_REMESSA_MALOTE_PDF_URL = API_URL + 'relatorios/desarquivados'
  let config = {
    method: 'get',
    url: GUIA_REMESSA_MALOTE_PDF_URL,
    params: {
      inicio: parameters.dataInicio + 'T' + parameters.horaInicio,
      fim: parameters.dataFim + 'T' + parameters.horaFim,
      idsUnidades: parameters.idsUnidades
    },
    responseType: 'arraybuffer',
    credentials: true
  }
  return Vue.http(config)
}
export default {
  getPDFGuiaRemessaMalote,
  getPDFDocumentosDesarquivadosSetor
}



// WEBPACK FOOTER //
// ./src/utils/relatorios.js